<script setup lang="ts">
const stats = [
  {
    value: "100+",
    description: "Coaching Videos",
    icon: "/images/training/videos.png",
  },
  {
    value: "75+",
    description: "Hours of Poker Training",
    icon: "/images/training/cards.png",
  },
  {
    value: "40+",
    description: "Professional Coaches",
    icon: "/images/training/coaches.png",
  },
];
</script>

<template>
  <div class="flex justify-center text-center">
    <div
      class="flex flex-col items-center justify-center rounded-xl border border-surface-border bg-surface-bg md:flex-row"
    >
      <div
        v-for="(stat, i) in stats"
        :key="`state_${i}`"
        :class="[
          'flex h-full items-center justify-center gap-5 px-7 py-5',
          { 'border-t border-surface-border md:border-l': i !== 0 },
        ]"
      >
        <div>
          <img :src="stat.icon" alt="state-thumbnail" />
        </div>
        <div class="text-left">
          <div class="text-4xl">
            {{ stat.value }}
          </div>
          <div class="w-32 text-sm opacity-50">
            {{ stat.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
